type RuntimeConfig = {
  APP_BASE_URL: string
  API_BASE_URL: string
  API_WEBSOCKET_URL: string
  PLAUSIBLE_API_BASE_URL: string
  PLAUSIBLE_ENABLED: boolean
  NODE_ENV: 'dev' | 'staging' | 'production',
  PAYPAL_CLIENT_ID: string,
  PAYPAL_PLAN_ID: string,
  CLOUDFLARE_SITE_KEY: string
}

// Use DEV environment as default configuration - not the PROD env
const defaultRuntimeConfig: RuntimeConfig = {
  APP_BASE_URL: 'dev.stockpulse.ai',
  API_BASE_URL: 'https://api.dev.stockpulse.ai',
  API_WEBSOCKET_URL: 'https://ws.dev.stockpulse.ai',
  NODE_ENV: 'dev',
  PLAUSIBLE_API_BASE_URL: 'https://plausible.stockpulse.ai',
  PLAUSIBLE_ENABLED: false,
  PAYPAL_CLIENT_ID: '',
  PAYPAL_PLAN_ID: '',
  CLOUDFLARE_SITE_KEY: ''
}

const useRuntimeConfig = (): RuntimeConfig => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window.runtimeConfig || defaultRuntimeConfig
}

export { useRuntimeConfig }
